module.exports = __webpack_public_path__ + "img/60_7.e35f56d3.png";